// Source: app/scripts/services/modal-scroll-lock-service.js
Auction.factory('ModalScrollLock', ['$window', '$timeout', function ($window, $timeout) {
  var scrollTop = 0;
  var locked = false;
  var body = angular.element(document.body);

  function readScrollTop() {
    return $window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function applyScrollPosition() {
    $window.scrollTo(0, scrollTop);
    if (document.documentElement) {
      document.documentElement.scrollTop = scrollTop;
    }
  }

  function lockBody() {
    if (locked) {
      return;
    }
    scrollTop = readScrollTop();
    locked = true;
    body.css({
      position: 'fixed',
      top: -scrollTop + 'px',
      left: '0',
      right: '0',
      width: '100%',
      height: 'auto',
      minHeight: '100%'
    });
  }

  function unlockBody() {
    var wasLocked = locked;
    locked = false;
    body.css({
      position: '',
      top: '',
      left: '',
      right: '',
      width: '',
      height: '',
      minHeight: '',
      overflow: ''
    });
    body.removeClass('modal-open');
    if (wasLocked) {
      applyScrollPosition();
      $timeout(applyScrollPosition, 0);
      $timeout(applyScrollPosition, 50);
      $timeout(applyScrollPosition, 250);
    }
  }

  return {
    capture: lockBody,
    release: unlockBody,
    restore: applyScrollPosition,
    bindScope: function (scope) {
      scope.$on('modal.show.before', lockBody);
      scope.$on('modal.hide', unlockBody);
      scope.$on('$destroy', unlockBody);
    }
  };
}]);
